import {
  PMSmallNumber,
  PMSmallNumberCardEditSchema,
} from "@pimo/pimo-components/src/lib/pm-components";

import { isFieldEnabled } from "../../field-enabled";
import { DashboardCardContext } from "../context";

export function addNumberOfCompletedProjectsCard(ctx: DashboardCardContext) {
  const { view, language, getCardCopy } = ctx;

  const numberOfCompletedProjectsComponent = view.addComponent({
    component: PMSmallNumber,
    layoutProps: {
      componentId: "numberOfCompletedProjectsComponent",
      title: "",
      description: "",
      labels: ["#ofCompletedProjects"],
      editSchema: PMSmallNumberCardEditSchema,
    },
  });

  numberOfCompletedProjectsComponent.mapLayoutProps(() => {
    return {
      componentId: "numberOfCompletedProjectsComponent",
      labels: ["#ofCompletedProjects"],
      description: getCardCopy(language, "numberOfCompletedProjects")
        .description,
      title: getCardCopy(language, "numberOfCompletedProjects").title,
      editSchema: PMSmallNumberCardEditSchema,
    };
  });

  numberOfCompletedProjectsComponent.mapState(({ dashboard }) => {
    return {
      title: getCardCopy(language, "numberOfCompletedProjects").title,
      number: dashboard?._calculated?.numberOfClosedProjects ?? 0,
    };
  });

  numberOfCompletedProjectsComponent.mapVisibility(({ settings }) =>
    isFieldEnabled(settings, "completion", "itemReporting")
  );
}
